// Canonical message-focus suggestions for Promotion Studio.
// The Studio uses these as datalist suggestions while still allowing a
// specific custom focus when a campaign needs one.

export const PROMOTION_MESSAGE_FOCUS_OPTIONS = [
  { value: "event_announcement", label: "Event Announcement" },
  { value: "qr_code_voting", label: "QR-Code Voting" },
  { value: "peoples_choice_voting", label: "People's Choice Voting" },
  { value: "ranked_choice_voting", label: "Ranked Choice Voting" },
  { value: "scorecard_voting", label: "Scorecard Voting" },
  { value: "judged_points", label: "Judged Points" },
  { value: "registration", label: "Registration" },
  { value: "event_reminder", label: "Event Reminder" },
  { value: "event_results", label: "Event Results" },
  { value: "winners", label: "Winners" },
  { value: "sponsors", label: "Sponsors" },
  { value: "volunteers", label: "Volunteers" },
  { value: "security", label: "Security" },
  { value: "integrity", label: "Integrity" },
  { value: "validation", label: "Validation" },
  { value: "trust", label: "Trust" },
  { value: "thank_you", label: "Thank You" },
  { value: "general_promotion", label: "General Promotion" },
];
